import ApiService from './ApiService'

const ContractService = {
    download(fileId, fileName) {
        return ApiService.downloadFile('contract.download', fileName, { contract_file: fileId })
    },

    fetchFilesList(contract, type) {
        return ApiService.get(`contract.files.${type}`, contract)
    },

    delete(file) {
        return ApiService.delete('contract.files.destroy', file)
    },

    updatePolicyId(fileId, policyId) {
        return ApiService.patch(
            'contract_file.update_policy_id',
            { policy_id: policyId },
            { contract_file: fileId }
        )
    },

    preview(fileId) {
        return ApiService.get('contract.preview', { contract_file: fileId })
    },
}

export default ContractService
